/* eslint-disable */
import { ORM, fk, many, attr, Model } from "redux-orm";
// , oneToOne
class Settings extends Model {}
Settings.modelName = "Settings";
Settings.fields = {
  id: attr(),
  username: attr(),
  password: attr(),
  groups: many("RX_Group"),
  boards: many("RX_Board"),
  error: attr(),
  requests: attr(), // number of unanswered requests to server
  token: attr(),
  isFullScreen: attr()
};

class RX_Page extends Model {}
RX_Page.modelName = "RX_Page";
RX_Page.fields = {
  id: attr(),
  type: attr(),
  config: attr(),
  browserdata: attr(),
  formdata: attr(),
  formtype: attr(),
  formcurrent: attr()
};

class RX_Report extends Model {}
RX_Report.modelName = "RX_Report";
RX_Report.fields = {
  id: attr(),
  type: attr(),
  config: attr(),
  definition: attr(),
  interval: attr(),
  name: attr(),
  runtime: attr(),
  status: attr(),
  data: attr(),
  filterdata: attr(),
  searchVisible: attr()
};

class RX_Alert extends Model {}
RX_Alert.modelName = "RX_Alert";
RX_Alert.fields = {
  id: attr(),
  label: attr(),
  status: attr(),
  severity: attr()
};

class RX_Board extends Model {}
RX_Board.modelName = "RX_Board";
RX_Board.fields = {
  id: attr(),
  label: attr(),
  link: attr(),
  icon: attr(),
  definition: attr(),
  type: attr(), // Admin board ise 1, diğerleri ise 0 olabilir...
  status: attr(),
  users: many("RX_User"),
  teams: many("RX_Group"),
  reports: attr(),
  searchVisible: attr()
};

class RX_Folder extends Model {}
RX_Folder.modelName = "RX_Folder";
RX_Folder.fields = {
  id: attr(),
  definition: attr(),
  label: attr(),
  icon: attr(),
  url: attr(),
  status: attr(),
  config: attr(),
  boards: attr(),
  children: attr(),
  hide: attr(),
  collapsed: attr()
};

class RX_Chart extends Model {}
RX_Chart.modelName = "RX_Chart";
RX_Chart.fields = {
  id: attr(),
  label: attr(),
  url: attr()
};

class RX_Chart_Preview extends Model {}
RX_Chart_Preview.modelName = "RX_Chart_Preview";
RX_Chart_Preview.fields = {
  id: attr(),
  svg: attr(),
  label: attr(),
  tooltip: attr(),
  chart: fk("RX_Chart")
};

class RX_Page_Config extends Model {}
RX_Page_Config.modelName = "RX_Page_Config";
RX_Page_Config.fields = {
  id: attr(),
  link: attr(),
  model: attr(),
  browser: attr(),
  form: attr()
};

class RX_Group extends Model {}
RX_Group.modelName = "RX_Group";
RX_Group.fields = {
  id: attr(),
  label: attr(),
  status: attr()
};

class RX_User extends Model {}
RX_User.modelName = "RX_User";
RX_User.fields = {
  id: attr(),
  username: attr(),
  label: attr(),
  status: attr(),
  email: attr(),
  team: fk("RX_Group")
};

const orm = new ORM();
orm.register(
  Settings,
  RX_Page,
  RX_Alert,
  RX_Folder,
  RX_Board,
  RX_Chart,
  RX_Chart_Preview,
  RX_Page_Config,
  RX_Report,
  RX_Group,
  RX_User
);

export default orm;



// WEBPACK FOOTER //
// ./src/models.js